import * as React from "react"
import { Modal, Col, Row, Spinner, Button, Form } from "react-bootstrap"
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import RegulatoryMode from "../../api/LabService/LabServiceModel/RegulatoryMode"
import AutoFilterLocation from "../../api/Location/LocationModel/AutoFilterLocation"
import LabServiceRegulatoryModesGetObservable from "../../api/LabService/LabServiceRegulatoryModesGet"
import { APIError } from "../../api/ObservableFromFetch"
import PoolCriteria, { CopyFilterDataNames, CopyPoolCriteria, EmptyPoolCriteria, FilterData, FilterDataName, FilterDataToPoolCriteria, GetCompanyPoolCriteriaItem, GetFilterDataNameIndexByID, GetPoolCriteria, GetPoolCriteriaItemStringValues, GetRegulatoryModePoolCriteriaItem, GetSavedQueries, GetSavedQuery, SavePoolCriteria, SaveQueryAs, GetPoolCriteriaItemByCode, FilterCriteriaCode } from "../../api/Randoms/RandomsModel/PoolCriteria"
import ActionButton from "../ActionButton"
import QueryNameModal from "./QueryNameModal"
import RegulatoryModeSelection from "./RegulatoryModeSelection"
import SavedQueriesModal from "./SavedQueriesModal"
import LocationSelection from "./LocationSelection"
import AutoFilterLocationsGetObservable from "../../api/Location/AutoFilterLocationsGet"
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"
import CompanySelection from "./CompanySelection"
import { GetConsortiumCompaniesObservable } from "../../api/Randoms/ConsortiumData"
import ConfirmationModal from "../ConfirmationModal"

interface PoolMembersCriteriaModalProps {
  poolId: number
  poolName: string
  regulated: boolean
  show: boolean
  onSave: (close: boolean) => void
  onClose: () => void
  isConsortium: boolean
  useFileImportForPoolMembership: boolean
}

interface PoolMembersCriteriaModalState {
  availableRegulatoryModes: RegulatoryMode[]
  isRegulatoryModesLoading: boolean
  availableCompanies: AutoFilterCompany[]
  selectedCompanies: AutoFilterCompany[]
  availableLocations: AutoFilterLocation[]
  selectedLocations: AutoFilterLocation[]
  loadingLocations: boolean
  isPoolCriteriaLoading: boolean
  isSavedQueriesLoading: boolean
  isSavedQueryLoading: boolean
  showRegulatoryModes: boolean
  showLocations: boolean
  showCompanies: boolean
  showSavedQueries: boolean
  showQueryName: boolean
  poolCriteria: PoolCriteria
  savedQueries: FilterDataName[]
  criteriaSaving: boolean
  querySaving: boolean
  querySavingAs: boolean
  saveQueryMode: string
  originalCompanies: AutoFilterCompany[]
  originalLocations: AutoFilterLocation[]
  showConfirmSave: boolean
  confirmSaveText: string

}

export default class PoolMembersCriteriaModal extends React.Component<PoolMembersCriteriaModalProps, PoolMembersCriteriaModalState> {
  saveSubscription?: Subscription
  saveAsSubscription?: Subscription
  loadSavedQuerySubscription?: Subscription
  state: PoolMembersCriteriaModalState = {
    availableRegulatoryModes: [],
    isRegulatoryModesLoading: false,
    availableLocations: [],
    selectedLocations: [],
    availableCompanies: [],
    selectedCompanies: [],
    loadingLocations: true,
    isPoolCriteriaLoading: false,
    isSavedQueriesLoading: false,
    isSavedQueryLoading: false,
    showRegulatoryModes: false,
    showLocations: false,
    showCompanies: false,
    showSavedQueries: false,
    showQueryName: false,
    poolCriteria: EmptyPoolCriteria,
    savedQueries: [],
    criteriaSaving: false,
    querySaving: false,
    querySavingAs: false,
    saveQueryMode: "",
    originalCompanies: [],
    originalLocations: [],
    showConfirmSave: false,
    confirmSaveText: ""
  }

  subscriptions = new Subscription()
  locationSubscription?: Subscription

  componentDidMount() {
    if (this.props.regulated) {
      this.setState({ isRegulatoryModesLoading: true, loadingLocations: true })
      this.subscriptions.add(
        LabServiceRegulatoryModesGetObservable().subscribe(
          (data: RegulatoryMode[]) => this.setState({ availableRegulatoryModes: data, isRegulatoryModesLoading: false }),
          () => this.setState({ isRegulatoryModesLoading: false })
        )
      )
    }

    this.setState({ isPoolCriteriaLoading: true, isSavedQueriesLoading: true, loadingLocations: true })
    this.subscriptions.add(
      GetPoolCriteria(this.props.poolId).subscribe(
        (data: PoolCriteria) => {
          this.setState({ poolCriteria: data, isPoolCriteriaLoading: false })
          const companyItem = GetCompanyPoolCriteriaItem(this.state.poolCriteria)

          if (this.props.isConsortium) {
            this.locationSubscription = GetConsortiumCompaniesObservable(this.props.poolId).subscribe(
              (data: AutoFilterCompany[]) => {
                const selectedCompanies = this.getSelectedCompanies(this.state.poolCriteria, data)
                this.setState({ availableCompanies: data, selectedCompanies: selectedCompanies, originalCompanies: selectedCompanies, loadingLocations: false })
              },
              () => this.setState({ loadingLocations: false })
            )
          }
          else {
            const companyID = companyItem.Values.length ? companyItem.Values[0].IntValue : 0
            this.locationSubscription = AutoFilterLocationsGetObservable(companyID, "", "").subscribe(
              (data: AutoFilterLocation[]) => {
                const selectedLocations = this.getSelectedLocations(this.state.poolCriteria, data)
                this.setState({ availableLocations: data, selectedLocations: selectedLocations, originalLocations: selectedLocations, loadingLocations: false })
              },
              () => this.setState({ loadingLocations: false })
            )
          }
        },
        () => this.setState({ isPoolCriteriaLoading: false })
      )
    )
    this.subscriptions.add(
      GetSavedQueries(0).subscribe(
        (data: FilterDataName[]) => this.setState({ savedQueries: data, isSavedQueriesLoading: false }),
        () => this.setState({ isSavedQueriesLoading: false })
      )
    )
  }

  componentWillUnmount() {
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveAsSubscription && this.saveAsSubscription.unsubscribe()
    this.loadSavedQuerySubscription && this.loadSavedQuerySubscription.unsubscribe()
    this.subscriptions.unsubscribe()
    this.locationSubscription && this.locationSubscription.unsubscribe()
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  confirmSave = () => {
    if (!this.props.isConsortium || !this.props.useFileImportForPoolMembership){
      this.handleSave()
      return
    }
    const deletedCompanies = this.getDeletedCompanies()
    if (deletedCompanies.length > 0) {
      this.setState({ showConfirmSave: true, confirmSaveText:this.getConfirmText(deletedCompanies)})
    } else {
      this.handleSave()
    }
  }

  getDeletedCompanies = (): AutoFilterCompany[] => {
    const companyCriteria = GetCompanyPoolCriteriaItem(this.state.poolCriteria)
    const originalCompanies = this.state.originalCompanies
    const deletedCompanies = originalCompanies.filter(c => !companyCriteria.Values.find(item => item.IntValue === c.AccountID))
    return deletedCompanies || []
  }

  getConfirmText = (deletedCompanies: AutoFilterCompany[]): string => {
    if (deletedCompanies.length === 0) {
      return ""
    }
    if (deletedCompanies.length === 1) {
      return "You removing a company from the pool and all members in the company will be marked as inactive.\
      Do you want to continue?"
    }
    return  "You have removed " + deletedCompanies.length + " companies from the pool.\
    All members of these companies will be marked as inactive.\
    Do you want to continue?"
  }

  handleConfirmSave = () => {
    this.setState({ showConfirmSave: false})
    this.handleSave()
  }

  handleConfirmClose = () => {
    this.setState({ showConfirmSave: false })
  }

  handleSave = () => {
    this.setState({ criteriaSaving: true })
    this.saveSubscription && this.saveSubscription.unsubscribe()
    const data = { ...this.state.poolCriteria, IsConsortium: this.props.isConsortium }
    this.saveSubscription = SavePoolCriteria(data).subscribe(
      (data: PoolCriteria) => {
        this.setState({ criteriaSaving: false })
        toast.success("Criteria saved successfully.")
        this.props.onSave(true)
      },
      error => this.handleAPIError(error, { criteriaSaving: false })
    )
  }

  handleSaveQuery = () => {
    if ((this.state.poolCriteria.FilterDataID === 0) || (this.state.poolCriteria.SaveAs.length === 0)) {
      this.setState({ showQueryName: true, saveQueryMode: "save" })
    }
    else {
      this.handleQueryNameSave(this.state.poolCriteria.SaveAs, "save")
    }
  }
  handleSaveQueryAs = () => {
    this.setState({ showQueryName: true, saveQueryMode: "save_as" })
  }

  handleQueryNameSave = (name: string, save_mode: string = "") => {
    if (name.trim().length === 0) {
      this.setState({ showQueryName: false, querySaving: false, querySavingAs: false, saveQueryMode: "" })
      return
    }
    const save_query_mode = save_mode || this.state.saveQueryMode;
    const querySaving = (save_query_mode === "save")
    const querySavingAs = (save_query_mode === "save_as")
    this.setState({ showQueryName: false, querySaving: querySaving, querySavingAs: querySavingAs })
    this.saveAsSubscription && this.saveAsSubscription.unsubscribe()
    this.saveAsSubscription = SaveQueryAs(this.state.poolCriteria, name).subscribe(
      (data: FilterData) => {
        const filterDataId = data.FilterDataID;
        const itemIndex = GetFilterDataNameIndexByID(this.state.savedQueries, filterDataId);
        let savedQueries = this.state.savedQueries;
        if (itemIndex < 0) {

          const newFilterDataItem = {
            FilterDataID: filterDataId,
            Name: data.Name
          }
          savedQueries = CopyFilterDataNames(this.state.savedQueries);
          savedQueries.push(newFilterDataItem);
        }

        const loadedPoolCriteria: PoolCriteria = FilterDataToPoolCriteria(this.state.poolCriteria.PoolID, data)
        const selectedLocations = this.getSelectedLocations(loadedPoolCriteria, this.state.availableLocations)
        this.setState({ poolCriteria: loadedPoolCriteria, selectedLocations: selectedLocations, savedQueries: savedQueries, querySaving: false, querySavingAs: false, saveQueryMode: "" })
        toast.success(data.SaveResultText)
      },
      error => this.handleAPIError(error, { querySaving: false, querySavingAs: false, saveQueryMode: "" })
    )
  }

  handleQueryNameClose = () => {
    this.setState({ showQueryName: false })
  }

  handleClearFilter = () => {
    const poolCriteria = CopyPoolCriteria(this.state.poolCriteria)
    const poolCriteriaItem = GetRegulatoryModePoolCriteriaItem(poolCriteria);
    const locationCriteria = GetPoolCriteriaItemByCode(poolCriteria, FilterCriteriaCode.Location)
    poolCriteriaItem.Values = []
    locationCriteria.Values = []
    this.setState({ poolCriteria: poolCriteria, selectedLocations: [] })
  }

  handleClose = () => {
    this.props.onClose()
  }

  handleSelectSavedQuery = (filterDataId: number, name: string) => {
    this.setState({ showSavedQueries: false, isSavedQueryLoading: true })
    this.loadSavedQuerySubscription && this.loadSavedQuerySubscription.unsubscribe()
    this.loadSavedQuerySubscription = GetSavedQuery(filterDataId, name).subscribe(
      (data: FilterData) => {
        //preserve Company
        const companyItem = GetCompanyPoolCriteriaItem(this.state.poolCriteria)
        const loadedPoolCriteria: PoolCriteria = FilterDataToPoolCriteria(this.state.poolCriteria.PoolID, data, true)
        loadedPoolCriteria.Items.push(companyItem)

        const selectedLocations = this.getSelectedLocations(loadedPoolCriteria, this.state.availableLocations)
        const locationCriteria = GetPoolCriteriaItemByCode(loadedPoolCriteria, FilterCriteriaCode.Location, true)
        locationCriteria.Values = selectedLocations.map(item => ({ ID: 0, IntValue: item.AccountID || 0, StringValue: item.Name, BoolValue: false }))

        this.setState({ poolCriteria: loadedPoolCriteria, selectedLocations: selectedLocations, isSavedQueryLoading: false })
        toast.success("Query loaded successfully.")
      },
      error => this.handleAPIError(error, { isSavedQueryLoading: false })
    )
  }

  handleDeleteSavedQuery = (filterDataId: number) => {

    let savedQueries = this.state.savedQueries;
    const itemIndex = GetFilterDataNameIndexByID(savedQueries, filterDataId);
    if (itemIndex >= 0) {
      savedQueries = CopyFilterDataNames(savedQueries);
      savedQueries.splice(itemIndex, 1)
    }

    this.setState({ showSavedQueries: false, savedQueries: savedQueries })
  }

  handleShowSavedQueries = () => {
    this.setState({ showSavedQueries: true })
  }

  handleRegulatoryModeChange = (items: RegulatoryMode[]) => {
    const poolCriteria = this.setRegulatorModes(items)
    this.setState({ showRegulatoryModes: false, poolCriteria: poolCriteria })
  }

  handleEditRegulatoryMode = () => this.setState({ showRegulatoryModes: true })

  handleLocationChange = (items: AutoFilterLocation[]) => {
    const poolCriteria = CopyPoolCriteria(this.state.poolCriteria)
    const locationCriteria = GetPoolCriteriaItemByCode(poolCriteria, FilterCriteriaCode.Location, true)
    locationCriteria.Values = items.map(item => ({ ID: 0, IntValue: item.AccountID || 0, StringValue: item.Name, BoolValue: false }))

    this.setState({ showLocations: false, poolCriteria: poolCriteria, selectedLocations: items })
  }

  handleCompanyChange = (items: AutoFilterCompany[]) => {
    const poolCriteria = CopyPoolCriteria(this.state.poolCriteria)
    const companyCriteria = GetPoolCriteriaItemByCode(poolCriteria, FilterCriteriaCode.Company, true)
    companyCriteria.Values = items.map(item => ({ ID: 0, IntValue: item.AccountID || 0, StringValue: item.Name, BoolValue: false }))

    this.setState({ showCompanies: false, poolCriteria: poolCriteria, selectedCompanies: items })
  }

  handleEdiLocation = () => this.setState({ showLocations: true })
  handleEditCompany = () => this.setState({ showCompanies: true })

  getSelectedRegulatoryModeModes = () => {
    let result: RegulatoryMode[] = [];
    let poolCriteriaItem = GetRegulatoryModePoolCriteriaItem(this.state.poolCriteria);
    let values = poolCriteriaItem.Values;
    let items = this.state.availableRegulatoryModes;
    for (let i = 0; i < values.length; i++) {
      let val = values[i];
      for (let j = 0; j < items.length; j++) {
        let item = items[j];
        if (item.RegulatoryModeID === val.IntValue) {
          result.push(item)
          break;
        }
      }
    }
    return result;
  }

  setRegulatorModes = (items: RegulatoryMode[]): PoolCriteria => {
    const poolCriteria = CopyPoolCriteria(this.state.poolCriteria)
    const poolCriteriaItem = GetRegulatoryModePoolCriteriaItem(poolCriteria);
    poolCriteriaItem.Values = []
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const val = {
        ID: 0,
        PoolCriteriaID: 0,
        PoolCriteriaIntID: 0,
        PoolOptionID: 0,
        IntValue: item.RegulatoryModeID,
        StringValue: item.Name,
        BoolValue: false
      }
      poolCriteriaItem.Values.push(val);
    }
    return poolCriteria;
  }


  getCompanyNames = () => {
    let item = GetCompanyPoolCriteriaItem(this.state.poolCriteria)
    const companies = item.Values.map(value => { return { ID: value.IntValue, Name: value.StringValue, CompanyName: value.StringValue2 || "", CompanyCode: value.StringValue3 || "" } })
    let names: string[] = []
    for (let i = 0; i < companies.length; i++) {
      let name = companies[i].CompanyName || ""
      let code = companies[i].CompanyCode ? companies[i].CompanyCode.toString() : ""
      if (code) {
        code = " (Company Code: " + code + ")"
      }
      names[i] = name + code
    }
    return names
  }

  getRegulatoryModeNames = () => {
    let item = GetRegulatoryModePoolCriteriaItem(this.state.poolCriteria)
    let result = GetPoolCriteriaItemStringValues(item)
    return result;
  }

  getSelectedLocations = (poolCriteria: PoolCriteria, availableLocations: AutoFilterLocation[]) => {
    const locationCriteria = GetPoolCriteriaItemByCode(poolCriteria, FilterCriteriaCode.Location)
    const locationIds = locationCriteria.Values.map(value => value.IntValue)
    return availableLocations.filter(location => locationIds.includes(location.AccountID || 0))
  }

  getSelectedCompanies = (poolCriteria: PoolCriteria, availableCompanies: AutoFilterCompany[]) => {
    const companyCriteria = GetPoolCriteriaItemByCode(poolCriteria, FilterCriteriaCode.Company)
    const companyIds = companyCriteria.Values.map(value => value.IntValue)
    return availableCompanies.filter(company => companyIds.includes(company.AccountID || 0))
  }

  getLocationNames = () => this.state.selectedLocations.map(item => item.Name)

  creatCompanyRow = (companyName: string) => {
    return <Row><Col>{companyName}</Col></Row>
  }
  creatCompanyRows = (items: string[]) => {
    let result = []
    for (let i = 0; i < items.length; i++) {
      result[i] = this.creatCompanyRow(items[i])
    }
    return result
  }
  render() {
    const { criteriaSaving, querySaving, querySavingAs, availableRegulatoryModes, availableLocations, selectedLocations, savedQueries, availableCompanies, selectedCompanies,
      isRegulatoryModesLoading, isPoolCriteriaLoading, isSavedQueriesLoading, showQueryName, isSavedQueryLoading, loadingLocations } = this.state
    const { regulated, isConsortium } = this.props
    const selectedRegulatoryModes = this.getSelectedRegulatoryModeModes()
    const companyNames = this.getCompanyNames() || []
    const companyRows = this.creatCompanyRows(companyNames)
    const regulatoryModeNames = this.getRegulatoryModeNames()
    const regulatoryModeNamesStr = regulatoryModeNames.join(", ")
    const locationNames = this.getLocationNames().join(", ")
    const loading = (regulated && isRegulatoryModesLoading) || isPoolCriteriaLoading || isSavedQueriesLoading || isSavedQueryLoading || loadingLocations
    const savedQueriesPresent = savedQueries.length > 0
    const isShowSaveQuery = true;
    const isShowSaveQueryAs = (this.state.poolCriteria.FilterDataID > 0)
    const isShowClose = true;
    const isShowClearFilter = true;
    const isShowSave = true;

    const saving = criteriaSaving || querySaving || querySavingAs;

    return (
      <>
        <QueryNameModal
          show={showQueryName}
          onSave={(name) => this.handleQueryNameSave(name)}
          onClose={this.handleQueryNameClose} />
        {savedQueriesPresent &&
          <SavedQueriesModal
            show={this.state.showSavedQueries}
            savedQueries={savedQueries}
            onClose={() => this.setState({ showSavedQueries: false })}
            onSelect={(filterDataId, name) => this.handleSelectSavedQuery(filterDataId, name)}
            onDelete={(filterDataId) => this.handleDeleteSavedQuery(filterDataId)} />
        }
        {this.props.regulated && <RegulatoryModeSelection
          show={this.state.showRegulatoryModes}
          regulatoryModes={availableRegulatoryModes}
          selectedRegulatoryModes={selectedRegulatoryModes}
          onClose={() => this.setState({ showRegulatoryModes: false })}
          onSave={(regModes) => this.handleRegulatoryModeChange(regModes)} />}
        <LocationSelection
          show={this.state.showLocations}
          locations={availableLocations}
          selectedLocations={selectedLocations}
          onClose={() => this.setState({ showLocations: false })}
          onSave={(locations) => this.handleLocationChange(locations)} />
        {!loadingLocations && <CompanySelection
          show={this.state.showCompanies}
          companies={availableCompanies}
          selectedCompanies={selectedCompanies}
          onClose={() => this.setState({ showCompanies: false })}
          onSave={(companies) => this.handleCompanyChange(companies)}
          isConsortium={isConsortium}
          poolID={this.props.poolId}
        />}
        {!loading && !saving &&
          <ConfirmationModal show={this.state.showConfirmSave}
            title=""
            textTitle=""
            text={this.state.confirmSaveText}
            showImage={false}
            cancelButtonText="No"
            confirmButtonText="Yes"
            onConfirm={() => this.handleConfirmSave()}
            onHide={() => this.handleConfirmClose()} />
        }

        <Modal backdrop="static" size="lg" centered show={this.props.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>CRITERIA</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(loading || saving) &&
              <Col>
                <Spinner animation="border" variant="secondary" />
              </Col>}

            {!loading && !saving &&
              <Form>
                <Row>
                  <Col sm={9} md={6} lg={3}>
                    <Form.Label></Form.Label>
                  </Col>
                  <Col sm={9} md={6} lg={3}>
                    <Form.Label>
                      {savedQueriesPresent &&
                        <Button variant="underline-link" onClick={() => this.handleShowSavedQueries()}>Saved Queries</Button>
                      }
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={9} md={6} lg={3}>
                    {!isConsortium && <Form.Label>Company</Form.Label>}
                    {isConsortium && <Button variant="underline-link" className="p-0 mx-0" onClick={this.handleEditCompany}>Company</Button>}
                  </Col>
                  <Col>
                    <Form.Label>{companyRows}</Form.Label>

                  </Col>
                  <Col sm={9} md={6} lg={3}>
                    <Form.Label></Form.Label>
                  </Col>
                </Row>
                {!isConsortium && <Row>
                  <Col sm={9} md={6} lg={3}>
                    <Button variant="underline-link" className="p-0 mx-0" onClick={this.handleEdiLocation}>Location</Button>
                  </Col>
                  <Col>
                    <Form.Label>{locationNames}</Form.Label>
                  </Col>
                  <Col sm={9} md={6} lg={3}>
                    <Form.Label></Form.Label>
                  </Col>
                </Row>}
                {regulated && <Row>
                  <Col sm={9} md={6} lg={3}>
                    <Form.Label>
                      <Button variant="underline-link" className="px-0 mx-0" onClick={() => this.handleEditRegulatoryMode()}>Regulatory Mode</Button>
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>{regulatoryModeNamesStr}</Form.Label>
                  </Col>
                  <Col sm={9} md={6} lg={3}>
                    <Form.Label></Form.Label>
                  </Col>
                </Row>}
              </Form>}
          </Modal.Body>
          <Modal.Footer>
            {isShowSaveQuery && <ActionButton variant="primary" spin={querySaving} onClick={() => this.handleSaveQuery()}>Save Query</ActionButton>}
            {isShowSaveQueryAs && <ActionButton variant="primary" spin={querySavingAs} onClick={() => this.handleSaveQueryAs()}>Save Query As</ActionButton>}
            {isShowClose && <ActionButton variant="secondary" onClick={() => this.handleClose()}>Cancel</ActionButton>}
            {isShowClearFilter && <ActionButton variant="primary" onClick={() => this.handleClearFilter()}>Clear Filter</ActionButton>}
            {isShowSave && <ActionButton variant="primary" spin={criteriaSaving} onClick={() => this.confirmSave()}>Save</ActionButton>}
          </Modal.Footer>
        </Modal >
      </>
    )
  }
}
